(function () {
  var a = {};
  a.util = {
    mobile: /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent),
    opera: ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0),
    mozilla: (typeof InstallTrigger !== "undefined"),
    code: function (n) {
      if (!n) {
        var n = window.event
      }
      if (n.code != undefined && n.key != undefined) {
        return n.code
      }
      return "Unidentified"
    },
    keyCode: function (o) {
      if (!o) {
        var o = window.event
      }
      if (this.mozilla) {
        var n = o.keyCode;
        switch (n) {
          case 59:
            n = 186;
            break;
          case 107:
            n = 187;
            break;
          case 109:
            n = 189;
            break;
          case 61:
            n = 187;
            break;
          case 173:
            n = 189;
            break
        }
        return n
      }
      if (this.opera) {
        var n = o.keyCode;
        switch (n) {
          case 59:
            n = 186;
            break;
          case 61:
            n = 187;
            break;
          case 109:
            n = 189;
            break
        }
        return n
      }
      return o.keyCode
    },
    isCtrl: function (n) {
      if (!n) {
        var n = window.event
      }
      return n.ctrlKey
    },
    isAlt: function (n) {
      if (!n) {
        var n = window.event
      }
      return n.altKey
    },
    isShift: function (n) {
      if (!n) {
        var n = window.event
      }
      return n.shiftKey
    },
    isCaps: function (n) {
      var o = this.keyCode(n);
      var p = this.isShift(n);
      if ((o >= 65 && o <= 90 && !p) || (o >= 97 && o <= 122 && p)) {
        return true
      }
      if ((o >= 65 && o <= 90 && p) || (o >= 97 && o <= 122 && !p)) {
        return false
      }
      return false
    },
    padLeft: function (n, e) {
      if (!e || n.length >= e) {
        return n
      }
      return Math.pow(10, e - n.length).toString().slice(1) + n
    },
    indexOf: function (e, p) {
      var o = e.length;
      for (var n = 0; n < o; n++) {
        if (e[n] == p) {
          return n
        }
      }
      return -1
    },
    keyOf: function (e, o) {
      for (var n in e) {
        if (n === "length" || !e.hasOwnProperty(n)) {
          continue
        }
        if (e[n] == o) {
          return n
        }
      }
      return null
    },
    insertAtCaret: function (n, r) {
      var q = this.getSelectionStart(n);
      var o = this.getSelectionEnd(n);
      var p = n.value.length;
      n.value = n.value.substring(0, q) + r + n.value.substring(o, p);
      this.setCaretPosition(n, q + r.length, 0)
    },
    deleteAtCaret: function (p, o, n) {
      var s = this.getSelectionStart(p);
      var q = this.getSelectionEnd(p);
      var r = p.value.length;
      if (o > s) {
        o = s
      }
      if (q + n > r) {
        n = r - q
      }
      var t = p.value.substring(s - o, q + n);
      p.value = p.value.substring(0, s - o) + p.value.substring(q + n);
      this.setCaretPosition(p, s - o, 0);
      return t
    },
    getSelectionStart: function (n) {
      n.focus();
      if (n.selectionStart !== undefined) {
        return n.selectionStart
      } else {
        if (document.selection) {
          var o = document.selection.createRange();
          if (o == null) {
            return 0
          }
          var q = n.createTextRange();
          var p = q.duplicate();
          q.moveToBookmark(o.getBookmark());
          p.setEndPoint("EndToStart", q);
          return p.text.length
        }
      }
      return 0
    },
    getSelectionEnd: function (n) {
      n.focus();
      if (n.selectionEnd !== undefined) {
        return n.selectionEnd
      } else {
        if (document.selection) {
          var o = document.selection.createRange();
          if (o == null) {
            return 0
          }
          var q = n.createTextRange();
          var p = q.duplicate();
          q.moveToBookmark(o.getBookmark());
          p.setEndPoint("EndToStart", q);
          return p.text.length + o.text.length
        }
      }
      return n.value.length
    },
    setCaretPosition: function (o, q, n) {
      var p = o.value.length;
      if (q > p) {
        q = p
      }
      if (q + n > p) {
        n = p - n
      }
      o.focus();
      if (o.setSelectionRange) {
        o.setSelectionRange(q, q + n)
      } else {
        if (o.createTextRange) {
          var r = o.createTextRange();
          r.collapse(true);
          r.moveEnd("character", q + n);
          r.moveStart("character", q);
          r.select()
        }
      }
      o.focus()
    },
    selectAll: function (n) {
      this.setCaretPosition(n, 0, n.value.length)
    }
  };
  String.fromCharCodeS = function () {
    var p = arguments.length;
    var q = "";
    var e, o, r;
    for (var n = 0; n < p; n++) {
      r = arguments[n];
      if (r < 1114112 && 65535 < r) {
        e = Math.floor((r - 65536) / 1024) + 55296;
        o = ((r - 65536) % 1024) + 56320;
        q = q + String.fromCharCode(e, o)
      } else {
        if (r < 65536) {
          q = q + String.fromCharCode(r)
        }
      }
    }
    return q
  };
  var j = document.getElementById("editor");
  var fontSizeOnStart = parseInt(window.getComputedStyle(j, null).getPropertyValue('font-size')) || 0;
  var g = {
    undo: [],
    redo: [],
    fontSize: fontSizeOnStart
  };
  var m = "unicode-table";
  if (document.cookie.indexOf("read=true") != -1) {
    document.getElementById("gdpr").style.display = "none"
  }
  // document.getElementById("gdpr-btn").onclick = function () {
  //   document.getElementById("gdpr").style.display = "none";
  //   document.cookie = "read=true"
  // };
  let srcId = function (n, o, q) {
    if (!n) {
      var n = window.event
    }
    var p;
    if (n.target) {
      p = n.target
    } else {
      if (n.srcElement) {
        p = n.srcElement
      }
    }
    if (p.nodeType == 3) {
      p = target.parentNode
    }
    while (p.tagName.toLowerCase() != q) {
      p = p.parentNode;
      if (p == o || p.tagName.toLowerCase() == "body") {
        return null
      }
    }
    return p.id
  };

  function l(n, e) {
    this.id = null;
    this.popup = n;
    this.textField = e;
    this.startCode = 0;
    this.counter = 0;
    this.interval = 0;
    this.initEvents()
  }
  l.prototype.initEvents = function () {
    var e = this;
    if (a.util.mobile) {
      e.textField.readOnly = true
    }
    document.getElementById("nav_goto").onclick = function (n) {
      e.go(n)
    };
    document.getElementById("unicode_value").onkeypress = function (o) {
      var n = a.util.code(o);
      if (n == "Unidentified") {
        if (a.util.keyCode(o) == 13) {
          e.go(o)
        }
      } else {
        if (n == "Enter") {
          e.go(o)
        }
      }
    };
    document.getElementById("rowsdown").onclick = function (n) {
      e.advanceRows(-7)
    };
    document.getElementById("rowsdown").onmousedown = function (n) {
      e.interval = setInterval(function () {
        e.counter++;
        if (e.counter > 5) {
          e.advanceRows(-7)
        }
      }, 50)
    };
    document.getElementById("rowsdown").onmouseup = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowsdown").onmouseout = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowsup").onclick = function (n) {
      e.advanceRows(7)
    };
    document.getElementById("rowsup").onmousedown = function (n) {
      e.interval = setInterval(function () {
        e.counter++;
        if (e.counter > 5) {
          e.advanceRows(7)
        }
      }, 50)
    };
    document.getElementById("rowsup").onmouseup = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowsup").onmouseout = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowdown").onclick = function (n) {
      e.advanceRows(-1)
    };
    document.getElementById("rowdown").onmousedown = function (n) {
      e.interval = setInterval(function () {
        e.counter++;
        if (e.counter > 5) {
          e.advanceRows(-1)
        }
      }, 50)
    };
    document.getElementById("rowdown").onmouseup = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowdown").onmouseout = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowup").onclick = function (n) {
      e.advanceRows(1)
    };
    document.getElementById("rowup").onmousedown = function (n) {
      e.interval = setInterval(function () {
        e.counter++;
        if (e.counter > 5) {
          e.advanceRows(1)
        }
      }, 50)
    };
    document.getElementById("rowup").onmouseup = function (n) {
      e.stopRepeat()
    };
    document.getElementById("rowup").onmouseout = function (n) {
      e.stopRepeat()
    };
    document.getElementById("script_list").onchange = function (n) {
      e.startCode = parseInt("0x" + this.value);
      e.advanceRows(0)
    };
    if (document.getElementById("script_list").value != "-1") {
      e.startCode = parseInt("0x" + document.getElementById("script_list").value + "00")
    }
    e.advanceRows(0);
    document.getElementById("char_grid").onclick = function (n) {
      var o = srcId(n, this, "button");
      if (!o) {
        return
      }
      if (o.search("r[0-7]c([0-9])|(1[0-5])") != -1) {
        a.util.insertAtCaret(e.textField, document.getElementById(o).innerHTML)
      }
    };
    document.getElementById("unicode_table_backspace").onclick = function (n) {
      a.util.deleteAtCaret(e.textField, 1, 0)
    };
    document.getElementById("unicode_table_backspace").onmousedown = function (n) {
      e.interval = setInterval(function () {
        e.counter++;
        if (e.counter > 5) {
          a.util.deleteAtCaret(e.textField, 1, 0)
        }
      }, 50)
    };
    document.getElementById("unicode_table_backspace").onmouseup = function (n) {
      e.stopRepeat()
    };
    document.getElementById("unicode_table_backspace").onmouseout = function (n) {
      e.stopRepeat()
    }
  };
  l.prototype.stopRepeat = function () {
    if (this.interval != 0) {
      clearInterval(this.interval);
      this.counter = 0;
      this.interval = 0
    }
  };
  l.prototype.showUnicodeTable = function (n) {
    this.popup.style.display = ""
  };
  l.prototype.go = function (o) {
    if (document.getElementById("unicode_value").value == "") {
      return false
    }
    var n = parseInt("0x" + document.getElementById("unicode_value").value);
    if (isNaN(n)) {
      return false
    }
    if (n < 0 || n > 1114111) {
      return false
    }
    this.startCode = parseInt(n / 16) * 16;
    this.advanceRows(0)
  };
  l.prototype.advanceRows = function (e) {
    if ((this.startCode + 16 * e) < 0 || 1114111 < (this.startCode + 16 * e)) {
      return
    }
    this.startCode = this.startCode + 16 * e;
    for (var n = 0; n < 8; n++) {
      document.getElementById("h" + n).innerHTML = a.util.padLeft((this.startCode / 16 + n).toString(16), 4).toUpperCase()
    }
    for (var n = 0; n < 8; n++) {
      for (var o = 0; o < 16; o++) {
        document.getElementById("r" + n + "c" + o).innerHTML = String.fromCharCodeS(this.startCode + (16 * n) + o)
      }
    }
  };
  var k = new l(document.getElementById("unicode_table_main"), document.getElementById("editor"));
  k.showUnicodeTable();
  var h = false;
  try {
    var d = "item";
    localStorage.setItem(d, d);
    localStorage.removeItem(d);
    h = true
  } catch (b) {}
  var f = false;
  try {
    var i = JSON.parse(JSON.stringify({
      item: "item"
    }));
    if (i.item == "item") {
      f = true
    }
  } catch (b) {}
  if (h && f) {
    var i = JSON.parse(localStorage.getItem(m));
    if (i != null && i.undo) {
      g.undo = i.undo
    }
    if (i != null && i.redo) {
      g.redo = i.redo
    }
    if (i != null && i.fontSize) {
      g.fontSize = i.fontSize
    }
  }
  var c = document.getElementById("char_grid");
  if (g.fontSize) {
    j.style.fontSize = g.fontSize + "px";
    if (c) {
      c.style.fontSize = g.fontSize + "px"
    }
  }
  document.getElementById("shrink").onclick = function () {
    if (g.fontSize < 14) {
      return
    }
    g.fontSize -= 2;
    j.style.fontSize = g.fontSize + "px";
    if (c) {
      c.style.fontSize = g.fontSize + "px"
    }
    if (h && f) {
      localStorage.setItem(m, JSON.stringify(g))
    }
    j.focus()
  };
  document.getElementById("resetSize").onclick = function () {
    if (g.fontSize == fontSizeOnStart) {
      return
    }
    g.fontSize = fontSizeOnStart;
    j.style.fontSize = g.fontSize + "px";
    if (c) {
      c.style.fontSize = g.fontSize + "px"
    }
    if (h && f) {
      localStorage.setItem(m, JSON.stringify(g))
    }
    j.focus()
  };
  document.getElementById("enlarge").onclick = function () {
    if (g.fontSize > 36) {
      return
    }
    g.fontSize += 2;
    j.style.fontSize = g.fontSize + "px";
    if (c) {
      c.style.fontSize = g.fontSize + "px"
    }
    if (h && f) {
      localStorage.setItem(m, JSON.stringify(g))
    }
    j.focus()
  };
  document.getElementById("selectAll").onclick = function () {
    a.util.setCaretPosition(j, 0, j.value.length);
    j.focus()
  };
  document.getElementById("copy").onclick = function () {
    a.util.setCaretPosition(j, 0, j.value.length);
    var e = document.execCommand("copy");
    if (e) {
      a.util.setCaretPosition(j, j.value.length, j.value.length);
    } else {
      alert("Your browser does not allow automated copy. To copy the text in the text area, you can click Select All button and right click on the selected text. Then click the Copy option.");
    }
    j.focus()
  };
  if (h && f) {
    if (g.undo.length > 0) {
      j.value = g.undo.pop()
    }
    document.getElementById("clearAll").onclick = function () {
      if (j.value.length < 10 || confirm("Are you sure you want to clear all the text?")) {
        g.undo = [];
        g.redo = [];
        localStorage.setItem(m, JSON.stringify(g));
        j.value = ""
      }
      j.focus()
    };
    document.getElementById("undo").onclick = function () {
      if (g.undo.length == 0) {
        return
      }
      var e = g.undo.pop();
      if (e != j.value) {
        g.redo.push(j.value);
        j.value = e
      } else {
        j.value = (g.undo.length == 0 ? "" : g.undo[g.undo.length - 1]);
        g.redo.push(e)
      }
      localStorage.setItem(m, JSON.stringify(g));
      j.focus()
    };
    document.getElementById("redo").onclick = function () {
      if (g.redo.length == 0) {
        return
      }
      var e = g.redo.pop();
      j.value = e;
      g.undo.push(e);
      localStorage.setItem(m, JSON.stringify(g));
      j.focus()
    };
    setInterval(function () {
      var e = j.value;
      if (g.undo.length == 0 && e.length == 0) {
        return
      }
      if (g.undo.length == 0 || e != g.undo[g.undo.length - 1]) {
        g.undo.push(e);
        localStorage.setItem(m, JSON.stringify(g))
      }
    }, 3000)
  } else {
    document.getElementById("undo").style.display = "none";
    document.getElementById("redo").style.display = "none";
    document.getElementById("clearAll").style.display = "none"
  }
})();
